<template>
  <div>
    <condition-part
      :hasCustomer="true"
      :hasExcel="true"
      :hasPdf="true"
      :hasAdd="false"
      :hasEdit="false"
      :hasRemove="false"
      :columns="columns"
      :items="items"
      :pagination="pagination"
      :isSortable="true"
      @getItems="getItems"
      @downloadExcel="downloadExcel"
      @downloadPdf="downloadPdf"
      @printPdf="printPdf"
    />
  </div>
</template>

<script>
import conditionPart from "@/components/parts/conditionPart";

export default {
  data() {
    return {
      items: [],
      pagination: {},
    };
  },
  components: {
    conditionPart,
  },
  computed: {
    hasShowmore() {
      return window.localStorage["hasShowmore"] == "true";
    },
    columns() {
      let c = [
        { name: "CustomerNumber" },
        { name: "CustomerName" },
        { name: "Degree", headerText: "會員等級" },
        { name: "Integral", headerText: "剩餘積分" },
        { name: "IntegralMinus", headerText: "使用積分" },
        { name: "Deposit", headerText: "剩餘儲值金", width: 150 },
        { name: "DepositMinus" },
        { name: "Total" },
      ];
      if (this.hasShowmore) {
        c.splice(
          c.findIndex((i) => i.name == "Integral"),
          1
        );
        c.splice(
          c.findIndex((i) => i.name == "IntegralMinus"),
          1
        );
        c.splice(
          c.findIndex((i) => i.name == "Deposit"),
          1
        );
        c.splice(
          c.findIndex((i) => i.name == "DepositMinus"),
          1
        );
      }
      return c;
    },
  },
  methods: {
    downloadExcel(condition) {
      this.$api.reportExcels.getCustomerSaleStatistic(condition);
    },
    downloadPdf(condition) {
      this.$api.reportPdfs.getCustomerSaleStatistic(condition);
    },
    printPdf(condition) {
      this.$api.reportPdfs.printCustomerSaleStatistic(condition);
    },
    getItems(condition) {
      const vm = this;
      this.$api.reports.getCustomerSaleStatistic(condition).then((data) => {
        vm.items = data.Datas;
        vm.pagination = data.Pagination;
      });
    },
  },
};
</script>
